import styled from '@emotion/styled';
import { Link, Modal, tokens } from '@hotjar/hotsauce';

export const HighlightBox = styled.div<{ textRightMargin?: number }>`
  background-color: ${tokens.BRAND_COLORS.cobalt_200};
  border-radius: 8px;
  display: flex;
  padding: 16px 24px;
  height: 160px;

  .text-part {
    flex-direction: column;
    display: flex;
    flex: 1;

    ${({ textRightMargin }) => textRightMargin && `margin-right: ${textRightMargin}px;`}
  }

  .image-part {
    display: flex;
  }

  h1 {
    margin-bottom: 8px;
  }
`;

export const Subtitle = styled.h1`
  ${tokens.text('subtitle1')};
  color: ${tokens.color.text_default};
`;

export const HighlightBoxImage = styled.img`
  width: 180px;
  height: 200px;
  margin-top: -32px;
`;

export const ModalBody = styled(Modal.Body)`
  padding-left: 40px !important;
  padding-right: 40px !important;
`;

export const CaptionLink = styled(Link)`
  ${tokens.text('caption')};
`;

export const TCBody = styled.div`
  margin-top: ${tokens.spacer.x6};
`;

export const BannerBox = styled.div`
  background-color: ${tokens.color.bg_info};
  border-radius: 8px;
  padding: 8px 16px 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;

  img {
    width: 44px;
    height: 40px;
    margin-bottom: 4px;
  }
`;

export const BannerTitle = styled.h1`
  ${tokens.text('subtitle3')};
  color: ${tokens.color.text_default};
  margin-bottom: 4px;
`;

export const BannerButton = styled.div`
  border-top: 1px dashed ${tokens.color.ui_border};
  padding-top: 12px;
  margin-top: 12px;
  text-align: center;
  cursor: pointer;
  ${tokens.text('subtitle3')};
`;

export const MessageBody = styled.div`
  margin-bottom: 40px;
`;
